<template>
  <div class="savings-card">
    <div class="savings-content">
      <div class="savings-header">
        <span class="savings-label">{{ getCurrentLabel() }}</span>
        <!-- <div class="info-icon">i</div> -->
      </div>
      <v-carousel
        v-model="currentDot"
        :show-arrows="false"
        :show-arrows-on-hover="false"
        hide-delimiter-background
        delimiter-icon="mdi-circle"
        height="auto"
        class="savings-carousel"
      >
        <v-carousel-item
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="savings-amount">
            {{ formatter.format(item.value) }}
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="pagination-dots">
      <div 
        v-for="(dot, index) in totalDots" 
        :key="index"
        :class="['dot', { active: index === currentDot }]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SavingsCard',
  props: {
    items: {
      type: Array,
      required: true,
      validator: function(value) {
        return value.every(item => 
          typeof item.value === 'number' && 
          typeof item.label === 'string'
        );
      }
    },
    formatter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentDot: 0
    }
  },
  computed: {
    totalDots() {
      return this.items.length;
    }
  },
  methods: {
    getCurrentLabel() {
      return this.items[this.currentDot]?.label || '';
    }
  }
}
</script>

<style scoped>
.savings-card {
  background: transparent;
  border-radius: 16px;
  padding: 24px;
  margin-top: 0px;
  margin-bottom: 0px;
  position: relative;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.savings-content {
  flex: 1;
}

.savings-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}

.savings-label {
  font-size: 16px;
  font-weight: bold;
  color: #4A3F6B;
}

.info-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(74, 63, 107, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #4A3F6B;
}

.savings-amount {
  font-size: 48px;
  font-weight: bold;
  color: #4A3F6B;
  text-align: center;
  margin: 0;
  line-height: 1;
}

.savings-carousel {
  background: transparent;
}

.savings-carousel ::v-deep(.v-carousel__controls) {
  display: none;
}

.savings-carousel ::v-deep(.v-carousel__progress) {
  display: none;
}

.savings-carousel ::v-deep(.v-carousel__delimiter) {
  display: none;
}

.pagination-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--light-text-color);
  transition: background-color 0.2s ease;
}

.dot.active {
  background-color: #4A3F6B;
}
</style> 